/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../hooks';
import { ColaboradorService } from '../services/api/rh/colaborador/ColaboradorService';


type TAutoCompleteOption = {
  label: string;
}

interface IAutoCompleteFazendaProps {
  isExternalLoading?: boolean;
  descricao?: (novoTextoselect: string | undefined) => void;
}
export const AutoCompleteCargo: React.FC<IAutoCompleteFazendaProps> = ({ isExternalLoading = false, descricao }) => {

  const { debounce } = useDebounce();
  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');
  const [value, setValue] = useState<TAutoCompleteOption | null>(null);


  useEffect(() => {
    setIsLoading(true);
    debounce(() => {  
      ColaboradorService.cargo(busca)
        .then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(cargo => ({ label: cargo.cargo })));
          }
        });
    });  
  }, [busca]);

 
  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={value}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => {
        setValue(newValue); 
        descricao?.(newValue?.label);
        setBusca('');
      }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Cargo" 
        />
      )}
    />
  );
};